import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createBookmarkAsync, fetchBookmarksAsync, fetchHomeBookmarkAsync } from '../../../../redux/bookmark/Actions';

import { MAIN_MAP } from '../../../../redux/map/Constants';
import { withStyles } from '@material-ui/core/styles';
import {
    FormControlLabel,
    Modal,
    Typography,
    Checkbox,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions
} from '@material-ui/core';
import {
    ViewFlagHover
} from '../../Icons';

import TextField from '../../../Common/UI/TextField';
import DialogButton from '../../../Common/UI/Dialog/DialogButton';

class CreateView extends React.Component {
    constructor (props) {
        super(props);

        this.createView = this.createView.bind(this);
        this.state = {
            name: '',
            home: true,
            rememberActiveLayers: false,
            nameError: null
        };
    }

    createView () {
        const {
            map,
            bookmarks,
            activeLayers,
            onClose,
            drawModule,
            dispatchCreateBookmarkAsync,
            dispatchToggleHomeBookmarkAsync,
            dispatchFetchBookmarks,
            dispatchFetchHomeBookmarkAsync
        } = this.props;
        const { name, home, rememberActiveLayers } = this.state;
        let viewConfig = {};
        if (map) {
            // Real time map values
            const rtMap = drawModule.props.map;
            // console.log(map, rtMap.getPitch(), rtMap.getBearing(), rtMap.getBounds())

            if (map.mapPosition) {
                const bounds = rtMap.getBounds();
                viewConfig.view = {
                    bounds: [
                        // map.mapPosition[1],
                        // map.mapPosition[3]

                        [bounds._ne.lng, bounds._ne.lat],
                        [bounds._sw.lng, bounds._sw.lat]
                    ],
                    pitch: [rtMap.getPitch()],
                    bearing: [rtMap.getBearing()]
                };
            } else {
                viewConfig.view = {
                    bounds: [[-11, 57.91640301580168], [2, 52.82616528013759]],
                    pitch: [0],
                    bearing: [-0]
                };
            }
            // console.log(viewConfig)
        }
        if (rememberActiveLayers) {
            viewConfig.selectedLayers = [...activeLayers.filter(al => al.visible)];
        }
        let view = {
            name: name,
            config_data: viewConfig,
            home: home
        };
        dispatchCreateBookmarkAsync(view);
        onClose();
    }

    render () {
        const { open, onClose, classes, activeLayers, map } = this.props;
        const { name, home, rememberActiveLayers, nameError } = this.state;
        return (
            <Dialog
                open={open}
                onClose={onClose}
                fullWidth
            >
                <DialogTitle disableTypography>
                    <ViewFlagHover className={classes.silver} />
                    <Typography variant="h4">
                        Save View
                    </Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <TextField
                        label="Location name"
                        fullWidth
                        variant="outlined"
                        value={name}
                        onChange={(e) => this.setState({
                            name: e.target.value
                        })}
                        error={Boolean(nameError)}
                        helperText={nameError}
                    />
                    <div>
                        <FormControlLabel
                            label="Set as Home View"
                            color="primary"
                            className={`${classes.grey} ${classes.label}`}
                            control={
                                <Checkbox
                                    checked={home}
                                    onChange={(e, newValue) => this.setState({ home: newValue })}
                                />}
                        />
                        <Typography
                            component="div"
                            variant="caption"
                            className={classes.grey}
                        >
                            Load this view automatically when you open LandHawk
                        </Typography>
                    </div>
                    { activeLayers.length > 0 && (
                        <div className={classes.rememberActiveLayers}>
                            <FormControlLabel
                                label={`Remember current Active Layers (${activeLayers.length})`}
                                color="primary"
                                className={`${classes.grey} ${classes.label}`}
                                control={
                                    <Checkbox
                                        checked={rememberActiveLayers}
                                        onChange={(e, newValue) => this.setState({ rememberActiveLayers: newValue })}
                                    />}
                            />
                        </div>
                    ) }
                </DialogContent>
                <DialogActions>
                    <DialogButton
                        variant="contained"
                        onClick={this.createView}
                    >
                        Save
                    </DialogButton>        
                    <DialogButton
                        variant="outlined"
                        onClick={onClose}
                    >
                        Cancel
                    </DialogButton>
                </DialogActions>
            </Dialog>
        );
    }
}

const styles = (theme) => ({
    grey: {
        color: theme.palette.grey.variant4
    },
    label: {
        '& > span': {
            fontSize: `${theme.typography.body2.fontSize} !important`
        }
    },
    silver: {
        '& > path:last-child': {
            fill: theme.palette.secondary.light
        },
        '& > path:first-child': {
            fill: theme.palette.grey.variant3
        }
    }
});

const mapStateToProps = (state) => ({
    activeLayers: state.activeLayers,
    layers: state.layers.layers,
    map: state[MAIN_MAP],
    baseLayer: state.layers.baseLayer,
    bookmarks: state.bookmarkReducer.bookmarks,
    homeBookmarkId: state.bookmarkReducer.homeBookmarkId,
    drawModule: state[MAIN_MAP].drawModule
});

const mapDispatchToProps = (dispatch) => ({
    dispatchCreateBookmarkAsync: (data) => dispatch(createBookmarkAsync(data)),
    dispatchToggleHomeBookmarkAsync: (id) => dispatch(toggleHomeBookmarkAsync(id)),
    dispatchFetchBookmarks: () => dispatch(fetchBookmarksAsync()),
    dispatchFetchHomeBookmarkAsync: () => dispatch(fetchHomeBookmarkAsync())
});

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles)
)(CreateView);